/* Galerii Perdele — Zoom pe poza din galeria foto (mobil)
   Zoom propriu (ciupit cu doua degete sau dublu-tap pe poza).
   Marirea porneste exact din punctul unde atingi/ciupesti — nu mai
   "sare" mereu din coltul din stanga-sus al pozei ca la prima varianta.
   Poti si sa micsorezi putin sub marimea normala (ciupind spre interior),
   ca sa ai o vedere putin mai larga inainte sa te repozitionezi si sa
   maresti exact pe detaliul dorit — util cand dublu-tap-ul sare direct
   la o marire fixa care nu e chiar in locul potrivit.
   Cand esti marit peste marimea normala, poza nu poate fi trasa in gol
   (in afara ecranului) — ramane mereu acoperind ecranul, ca la orice
   vizualizator de poze normal.
   Se reseteaza mereu corect la marimea normala cand inchizi si redeschizi
   fereastra — spre deosebire de zoom-ul nativ al telefonului, care putea
   ramane "blocat" marit. Functioneaza doar pe poza din fereastra marita a
   produsului; restul site-ului nu este afectat. */
(function () {
  var MIN_SCALE = 0.4;
  var MAX_SCALE = 4;
  var DOUBLE_TAP_SCALE = 2.5;
  var DOUBLE_TAP_WINDOW = 300;

  function distance(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function midpoint(touches) {
    return {
      x: (touches[0].clientX + touches[1].clientX) / 2,
      y: (touches[0].clientY + touches[1].clientY) / 2
    };
  }

  function setupZoomable(img) {
    if (img.dataset.gpZoomReady) return;
    img.dataset.gpZoomReady = 'true';

    var scale = 1;
    var translateX = 0;
    var translateY = 0;
    var startScale = 1;
    var startDist = 0;
    var isPanning = false;
    var panStartX = 0;
    var panStartY = 0;
    var panStartTranslateX = 0;
    var panStartTranslateY = 0;
    var lastTapTime = 0;

    img.style.transformOrigin = '0 0';

    function apply(withTransition) {
      img.style.transition = withTransition ? 'transform 0.2s ease' : '';
      img.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + scale + ')';
    }

    /* Schimba marimea pastrand fix pe ecran punctul (clientX, clientY) —
       adica exact locul unde ai atins/ciupit, nu coltul pozei. */
    function zoomAtPoint(newScale, clientX, clientY, withTransition) {
      newScale = Math.min(Math.max(newScale, MIN_SCALE), MAX_SCALE);
      var rect = img.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        var relX = (clientX - rect.left) / rect.width;
        var relY = (clientY - rect.top) / rect.height;
        var naturalWidth = rect.width / scale;
        var naturalHeight = rect.height / scale;
        var newWidth = naturalWidth * newScale;
        var newHeight = naturalHeight * newScale;
        translateX += (clientX - relX * newWidth) - rect.left;
        translateY += (clientY - relY * newHeight) - rect.top;
      }
      scale = newScale;
      apply(false);
      clampToViewport();
      apply(withTransition);
    }

    /* Cand poza (marita) e mai mare decat ecranul, nu o lasa trasa/impinsa
       astfel incat sa apara gol intre marginea pozei si marginea ecranului
       — o "prinde" de margini, ca intr-un vizualizator de poze normal.
       Cat timp poza e mai mica decat ecranul pe o directie (de exemplu in
       timp ce o micsorezi cu ciupitul), NU o forteaza inapoi in centru —
       asta ar suprascrie exact punctul de sub degete si ar da senzatia ca
       "sare" in loc sa se micsoreze lin de unde tii degetele. Revenirea
       perfect centrata, la marimea normala, se intampla oricum automat cand
       ajungi aproape de scara 1 (vezi reset-ul din touchend). */
    function clampToViewport() {
      if (scale <= 1.001) return;
      var rect = img.getBoundingClientRect();
      var vw = window.innerWidth;
      var vh = window.innerHeight;
      var dx = 0;
      var dy = 0;
      if (rect.width > vw) {
        if (rect.left > 0) {
          dx = -rect.left;
        } else if (rect.right < vw) {
          dx = vw - rect.right;
        }
      }
      if (rect.height > vh) {
        if (rect.top > 0) {
          dy = -rect.top;
        } else if (rect.bottom < vh) {
          dy = vh - rect.bottom;
        }
      }
      translateX += dx;
      translateY += dy;
    }

    img.gpZoomReset = function () {
      scale = 1;
      translateX = 0;
      translateY = 0;
      apply(false);
    };

    img.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length === 2) {
          startDist = distance(event.touches);
          startScale = scale;
        } else if (event.touches.length === 1 && scale > 1) {
          isPanning = true;
          panStartX = event.touches[0].clientX;
          panStartY = event.touches[0].clientY;
          panStartTranslateX = translateX;
          panStartTranslateY = translateY;
        }
      },
      { passive: true }
    );

    img.addEventListener(
      'touchmove',
      function (event) {
        if (event.touches.length === 2) {
          event.preventDefault();
          var newDist = distance(event.touches);
          if (startDist > 0) {
            var newScale = startScale * (newDist / startDist);
            var mid = midpoint(event.touches);
            zoomAtPoint(newScale, mid.x, mid.y, false);
          }
        } else if (event.touches.length === 1 && isPanning) {
          event.preventDefault();
          translateX = panStartTranslateX + (event.touches[0].clientX - panStartX);
          translateY = panStartTranslateY + (event.touches[0].clientY - panStartY);
          apply(false);
          clampToViewport();
          apply(false);
        }
      },
      { passive: false }
    );

    img.addEventListener('touchend', function (event) {
      isPanning = false;
      /* Doar cand esti FOARTE aproape de marimea normala (1x) faci un
         "clic" curat exact pe 1x, centrat perfect — nu si cand esti
         deliberat mai mic (sub ~0.95x), ca sa poti ramane acolo si sa te
         repozitionezi inainte sa maresti pe detaliu. */
      if (scale >= 0.95 && scale <= 1.05) {
        img.gpZoomReset();
      }
      if (event.touches.length === 0 && event.changedTouches.length === 1) {
        var now = Date.now();
        if (now - lastTapTime < DOUBLE_TAP_WINDOW) {
          if (scale > 1) {
            img.gpZoomReset();
          } else {
            var t = event.changedTouches[0];
            zoomAtPoint(DOUBLE_TAP_SCALE, t.clientX, t.clientY, true);
          }
          lastTapTime = 0;
        } else {
          lastTapTime = now;
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.product-media-modal__content img[data-media-id]').forEach(setupZoomable);
  }

  function resetAllIn(modal) {
    modal.querySelectorAll('.product-media-modal__content img[data-media-id]').forEach(function (img) {
      if (img.gpZoomReset) img.gpZoomReset();
    });
  }

  initAll();

  document.querySelectorAll('.media-modal').forEach(function (modal) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'open' && modal.hasAttribute('open')) {
          resetAllIn(modal);
        }
      });
    }).observe(modal, { attributes: true });
  });
})();
